const showOverflow = el => {
  const body = document.body
  const node = el || body

  if (node === body) {
    node.style.removeProperty('overflow')
    node.style.removeProperty('padding-right')
  }
}

export default showOverflow
